export default __webpack_public_path__ + "static/media/pinkCornerCircle.2752a9ce.svg";